// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__4qjkE","head":"Table_head__2XrMC","col":"Table_col__3AGfz"};